/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React from "react";
import { inject } from "mobx-react";
import { getGenAIViewerController } from "selectors/appSelectors";

const AssistantButton = props => {
  const { genAIViewerController } = props;
  if (genAIViewerController) {
    const GenAIAssitantButton = genAIViewerController.getAssistantAction();
    return <GenAIAssitantButton />;
  }
  return null;
};

const mapStoreToProps = (stores, ownProps) => ({
  genAIViewerController: getGenAIViewerController(stores)
});

export const AssistantButtonContainer = inject(mapStoreToProps)(AssistantButton);
